"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.array.find-index");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.number.constructor");
var _RegionStorePane = _interopRequireDefault(require("../RegionStorePane.vue"));
var _recommend_activity = require("@/api/goods_activity/recommend_activity");
var _goods_activity_combo = require("@/api/goods_activity/goods_activity_combo");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'RecommendActivityConfigPane',
  components: {
    RegionStorePane: _RegionStorePane.default
  },
  props: {
    activityId: {
      type: Number,
      default: null
    }
  },
  data: function data() {
    var _this = this;
    return {
      submitLoading: false,
      regionStoreList: [],
      dateRange: [],
      timeRange: ['09:00', '21:00'],
      checkedWeekdays: [],
      goodsList: [],
      checkedGoods: null,
      searchGoodsLoading: false,
      goodsTableKey: 0,
      form: {
        activityName: '',
        scenes: [],
        storeScope: 0,
        relatedStoreIdList: [],
        timeType: 1,
        startTime: '09:00',
        endTime: '21:00',
        weekdays: null,
        startDate: null,
        endDate: null,
        checkedGoodsList: [],
        status: 1
      },
      rules: {
        activityName: [{
          required: true,
          message: '请输入活动名称',
          trigger: 'blur'
        }],
        scenes: [{
          type: 'array',
          required: true,
          message: '请选择点餐类型',
          trigger: 'change'
        }],
        checkedGoodsList: [{
          type: 'array',
          required: true,
          message: '请选择推荐商品',
          trigger: 'change'
        }, {
          validator: function validator(rule, value, callback) {
            if (value && value.length > 3) {
              callback(new Error('最多只能选择3个商品'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }],
        relatedStoreIdList: [{
          validator: function validator(rule, value, callback) {
            if (_this.form.storeScope === 1 && (!value || value.length === 0)) {
              callback(new Error('请选择至少一个门店'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }]
      }
    };
  },
  watch: {
    dateRange: function dateRange(val) {
      if (val && val.length === 2) {
        this.form.startDate = val[0];
        this.form.endDate = val[1];
      } else {
        this.form.startDate = null;
        this.form.endDate = null;
      }
    },
    timeRange: function timeRange(val) {
      if (val && val.length === 2) {
        this.form.startTime = val[0];
        this.form.endTime = val[1];
      }
    },
    checkedWeekdays: function checkedWeekdays(val) {
      if (val && val.length > 0) {
        var weekdays = 0;
        val.forEach(function (day) {
          weekdays |= 1 << day - 1;
        });
        this.form.weekdays = weekdays;
      } else {
        this.form.weekdays = null;
      }
    }
  },
  created: function created() {
    this.getStoreList();
    if (this.activityId) {
      this.getDetail();
    }
  },
  methods: {
    getStoreList: function getStoreList() {
      var _this2 = this;
      (0, _goods_activity_combo.queryRegionStoreList)().then(function (res) {
        var data = res.data;
        if (data && data.storeRegions) {
          _this2.regionStoreList = data.storeRegions;
        }
      });
    },
    getDetail: function getDetail() {
      var _this3 = this;
      (0, _recommend_activity.getRecommendActivityDetail)(this.activityId).then(function (res) {
        var data = res.data;
        if (data) {
          _this3.form.activityId = data.activityId;
          _this3.form.activityName = data.activityName;
          _this3.form.scenes = data.scenes || [];
          _this3.form.storeScope = data.storeScope;
          _this3.form.relatedStoreIdList = data.relatedStoreIdList || [];
          _this3.form.timeType = data.timeType || 1;
          _this3.form.status = data.status || 1;
          if (data.startTime) {
            _this3.form.startTime = data.startTime.substring(0, 5);
          }
          if (data.endTime) {
            _this3.form.endTime = data.endTime.substring(0, 5);
          }
          _this3.timeRange = [_this3.form.startTime, _this3.form.endTime];
          if (data.startDate && data.endDate) {
            _this3.dateRange = [data.startDate, data.endDate];
          }
          if (data.weekdays) {
            _this3.checkedWeekdays = [];
            for (var i = 0; i < 7; i++) {
              if ((data.weekdays & 1 << i) !== 0) {
                _this3.checkedWeekdays.push(i + 1);
              }
            }
          }
          if (data.checkedGoodsList) {
            _this3.form.checkedGoodsList = data.checkedGoodsList.map(function (item) {
              return {
                goodsId: item.goodsId,
                goodsName: item.goodsName,
                goodsCode: item.goodsCode,
                goodsThumbnailUrl: item.goodsThumbnailUrl,
                sorts: item.sortOrder || item.sorts || 0
              };
            });
          }
        }
      });
    },
    handleTimeTypeChange: function handleTimeTypeChange(val) {
      if (val === 1) {
        this.dateRange = [];
        this.checkedWeekdays = [];
      } else if (val === 2) {
        this.checkedWeekdays = [];
      } else if (val === 3) {
        this.dateRange = [];
      }
    },
    handleStoreScopeChange: function handleStoreScopeChange(val) {
      if (val === 0) {
        this.form.relatedStoreIdList = [];
      }
    },
    handleStoreChange: function handleStoreChange(val) {
      for (var i = 0; i < val.length; i++) {
        var storeId = val[i];
        if (!this.form.relatedStoreIdList.includes(storeId)) {
          this.form.relatedStoreIdList.push(storeId);
        }
      }
    },
    searchGoods: function searchGoods(query) {
      var _this4 = this;
      this.searchGoodsLoading = true;
      (0, _goods_activity_combo.queryGoodsSearch)({
        keywords: query
      }).then(function (res) {
        var data = res.data;
        if (data) {
          _this4.goodsList = (data.goodsList || []).filter(function (item) {
            return !_this4.form.checkedGoodsList.some(function (g) {
              return g.goodsId === item.goodsId;
            });
          });
        }
        _this4.searchGoodsLoading = false;
      }, function () {
        _this4.searchGoodsLoading = false;
      });
    },
    addGoods: function addGoods() {
      var _this5 = this;
      if (this.checkedGoods && this.checkedGoods.goodsId) {
        var exist = this.form.checkedGoodsList.some(function (g) {
          return g.goodsId === _this5.checkedGoods.goodsId;
        });
        if (!exist) {
          this.form.checkedGoodsList.push({
            goodsId: this.checkedGoods.goodsId,
            goodsName: this.checkedGoods.goodsName,
            goodsCode: this.checkedGoods.goodsCode,
            goodsThumbnailUrl: this.checkedGoods.goodsThumbnailUrl,
            sorts: this.form.checkedGoodsList.length * 10
          });
          this.goodsTableKey++;
        }
        this.checkedGoods = null;
      }
    },
    removeGoods: function removeGoods(row) {
      var index = this.form.checkedGoodsList.findIndex(function (g) {
        return g.goodsId === row.goodsId;
      });
      if (index !== -1) {
        this.form.checkedGoodsList.splice(index, 1);
      }
    },
    submitForm: function submitForm() {
      var _this6 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this6.submitLoading = true;
          var submitData = _objectSpread(_objectSpread({}, _this6.form), {}, {
            scenes: _this6.form.scenes.map(String),
            checkedGoodsList: _this6.form.checkedGoodsList.map(function (item, index) {
              return {
                goodsId: item.goodsId,
                goodsName: item.goodsName,
                goodsCode: item.goodsCode,
                goodsThumbnailUrl: item.goodsThumbnailUrl,
                sortOrder: item.sorts !== undefined ? item.sorts : index * 10
              };
            })
          });
          (0, _recommend_activity.saveRecommendActivity)(submitData).then(function (res) {
            _this6.$message.success(res.message || '保存成功');
            _this6.$emit('success');
            _this6.submitLoading = false;
          }).catch(function () {
            _this6.submitLoading = false;
          });
        }
      });
    }
  }
};